"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopup = void 0;
var react_1 = require("react");
var Popup_styles_1 = require("./Popup.styles");
var utils_1 = require("./utils");
var usePopup = function (_a) {
    var open = _a.open, childRef = _a.childRef, directions = _a.directions, containerClassName = _a.containerClassName, parentElement = _a.parentElement, align = _a.align, offset = _a.offset, reposition = _a.reposition, boundaryInset = _a.boundaryInset, boundaryElement = _a.boundaryElement, onPositionPopup = _a.onPositionPopup;
    var popupRef = (0, react_1.useRef)();
    popupRef.current = (0, react_1.useMemo)(function () {
        var container = window.document.createElement('div');
        if (containerClassName) {
            container.className = containerClassName;
        }
        container.ariaExpanded = 'true';
        container.setAttribute('role', 'dialog');
        Object.assign(container.style, Popup_styles_1.PopupStyle);
        return container;
    }, [containerClassName, Popup_styles_1.PopupStyle]);
    var positionPopup = (0, react_1.useCallback)(function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.directionIndex, directionIndex = _d === void 0 ? 0 : _d, _e = _c.parentRect, parentRect = _e === void 0 ? parentElement.getBoundingClientRect() : _e, _f = _c.childRect, childRect = _f === void 0 ? (_b = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect() : _f, _g = _c.popupRect, popupRect = _g === void 0 ? popupRef.current.getBoundingClientRect() : _g, _h = _c.boundaryRect, boundaryRect = _h === void 0 ? boundaryElement === parentElement
            ? parentRect
            : boundaryElement.getBoundingClientRect() : _h;
        if (!childRect || !parentRect || !open) {
            return;
        }
        var isExhausted = directionIndex === directions.length;
        var direction = isExhausted ? directions[0] : directions[directionIndex];
        var _j = (0, utils_1.createNewRect)({
            childRect: childRect,
            popupRect: popupRect,
            boundaryRect: boundaryRect,
            direction: direction,
            align: align,
            offset: offset,
            reposition: reposition,
        }, boundaryInset), rect = _j.rect, boundaryCollision = _j.boundaryCollision;
        if (boundaryCollision && reposition && !isExhausted) {
            positionPopup({
                directionIndex: directionIndex + 1,
                childRect: childRect,
                popupRect: popupRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect,
            });
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldReposition = reposition && !isExhausted;
        var _k = (0, utils_1.getRepositionedRect)(rect, boundaryRect, boundaryInset), repositionedLeft = _k.left, repositionedTop = _k.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldReposition) {
            finalTop = repositionedTop;
            finalLeft = repositionedLeft;
        }
        popupRef.current.style.transform = "translate(".concat(finalLeft, "px, ").concat(finalTop, "px)");
        var potentialCollisions = {
            top: boundaryRect.top + boundaryInset - finalTop,
            left: boundaryRect.left + boundaryInset - finalLeft,
            right: finalLeft + width - boundaryRect.right + boundaryInset,
            bottom: finalTop + height - boundaryRect.bottom + boundaryInset,
        };
        onPositionPopup({
            childRect: childRect,
            popupRect: new DOMRect(finalLeft, finalTop, width, height),
            parentRect: parentRect,
            boundaryRect: boundaryRect,
            direction: direction,
            align: align,
            offset: offset,
            repositionedTop: repositionedTop - top,
            repositionedLeft: repositionedLeft - left,
            boundaryInset: boundaryInset,
            collisions: {
                top: potentialCollisions.top <= 0 ? 0 : potentialCollisions.top,
                left: potentialCollisions.left <= 0 ? 0 : potentialCollisions.left,
                right: potentialCollisions.right <= 0 ? 0 : potentialCollisions.right,
                bottom: potentialCollisions.bottom <= 0 ? 0 : potentialCollisions.bottom,
            },
            hasCollisions: potentialCollisions.top > 0 ||
                potentialCollisions.left > 0 ||
                potentialCollisions.right > 0 ||
                potentialCollisions.bottom > 0,
        });
    }, [
        parentElement,
        childRef,
        popupRef,
        boundaryElement,
        open,
        directions,
        align,
        offset,
        reposition,
        boundaryInset,
        onPositionPopup,
    ]);
    return {
        positionPopup: positionPopup,
        popupRef: popupRef,
    };
};
exports.usePopup = usePopup;
